import React, { useEffect, useState } from "react";
import Nav from "../master/NavBar";
import Header from "../master/SideBar";
import DocumentHeader from "./DocumentHeader";
import { getBatchList, ViewBatch } from "../../api/BatchService";
import { getSessions } from "../../api/SessionsService";
import {
  GetMarketingSchool,
  MarketingStudentList,
} from "../../api/MarketinService";
import { StaffList } from "../../api/Staff";
import {
  DistributionAdd,
  DistributionAlreadyGiven,
  fetchCategories,
} from "../../api/Documents";
import { SweetAlertShow } from "../master/Master";
import { useNavigate } from "react-router-dom";
import { enquiryList } from "../../api/Enquiry";

const DocumentsDistribution = () => {
  const [alreadyGivenIds, setAlreadyGivenIds] = useState([]);
  const navigate = useNavigate();

  const today = new Date().toISOString().slice(0, 10);

  const [distType, setDistType] = useState("");

  const [sessions, setSessions] = useState([]);
  const [sessionId, setSessionId] = useState("");

  const [batch, setBatch] = useState("");
  const [batchList, setBatchList] = useState([]); // 👈 API list
  const [batchId, setBatchId] = useState(""); // 👈 selected batch
  const [loading, setLoading] = useState(false);

  const [students, setStudents] = useState([]);

  const [source, setSource] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [allSelect, setAllSelect] = useState(false);

  const [marketingSources, setMarketingSources] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [staffs, setStaffs] = useState([]);

  const [categories, setCategories] = useState([]);

  const [courses, setCourses] = useState([]);

  const [kits, setKits] = useState([
    {
      category_id: "",
      quantity: 1,
      remark: "",
      distribution_date: today, // ✅ by default today
      collect: "NO",
    },
  ]);

  const fetchSessions = async () => {
    try {
      const res = await getSessions();
      console.log("SESSION API RESPONSE 👉", res?.data);

      if (res?.data?.status) {
        setSessions(res.data.data || []);
        const active = res.data.data.find((s) => s.status === "1");
        setSessionId(active?.id || "");
      }
    } catch (e) {
      console.error("Session fetch error", e);
    }
  };

  /* ---------- Dummy Data (API se batch) ---------- */
  const fetchBatchList = async (session_id) => {
    setLoading(true);
    try {
      const addUrl = `&status=1&session_id=${session_id}`;
      const response = await getBatchList(addUrl);

      if (response?.data?.status) {
        setBatchList(response.data.batches || []);
      } else {
        setBatchList([]);
      }
    } catch (e) {
      console.error(e);
      setBatchList([]);
    } finally {
      setLoading(false);
    }
  };
  /* ---------- Dummy Data (API se aayega) ---------- */
  const fetchStudentsByBatch = async (batchId) => {
    setLoading(true);
    try {
      const response = await ViewBatch(
        batchId,
        `&status=active&session_id=${sessionId}`
      );

      if (response?.data?.status) {
        const formatted = response.data.batch.BatchStudents.map((s) => ({
          id: s.student_id,
          name: s.student_info?.name || "N/A",
          reg_no: s.student_info?.registration_no || "—",
        }));
        setStudents(formatted);
      } else {
        setStudents([]);
      }
    } catch (e) {
      console.error(e);
      setStudents([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchDemoStudentsByBatch = async (batchId) => {
    setLoading(true);
    try {
      const response = await enquiryList(
        `status=4&batch_id=${batchId}&session_id=${sessionId}`
      );

      if (response?.data?.status) {
        const formatted = response.data.data.map((s) => ({
          id: s.id,
          name: s.student_name || "N/A",
          reg_no: s.enquiry_no || s.id,
        }));
        setStudents(formatted);
      } else {
        setStudents([]);
      }
    } catch (e) {
      console.error(e);
      setStudents([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchMarketingSources = async () => {
    setLoading(true);
    try {
      const addUrl = `&session=${sessionId}`;
      const response = await GetMarketingSchool(addUrl);

      if (response?.data?.status) {
        const formatted = (response.data.data || []).map((s) => ({
          id: s.id,
          name: s.source_name,
          reg_no: s.id || "—",
        }));
        setMarketingSources(formatted);
      } else {
        setMarketingSources([]);
      }
    } catch (e) {
      console.error(e);
      setMarketingSources([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchMarketingStudents = async (sourceId, pageNo = 1) => {
    setLoading(true);
    try {
      const addUrl = `&session=${sessionId}&source_id=${sourceId}&page=${pageNo}`;
      const response = await MarketingStudentList(addUrl);

      if (response?.data?.status) {
        const paginated = response.data.data;

        setStudents(
          (paginated.data || []).map((s) => ({
            id: s.id,
            name: s.name || "N/A",
            reg_no: s.id || "—",
          }))
        );

        setPage(paginated.current_page);
        setTotalPages(paginated.last_page);
      } else {
        setStudents([]);
      }
    } catch (e) {
      console.error(e);
      setStudents([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchStaffs = async () => {
    setLoading(true);
    try {
      const addUrl = `&status=1`; // active staff
      const response = await StaffList(addUrl);

      if (response?.data?.status) {
        const formatted = (response.data.data || []).map((s) => ({
          id: s.id,
          name: s.name,
          reg_no: s.registration_no || s.id || "—",
        }));
        setStaffs(formatted);
      } else {
        setStaffs([]);
      }
    } catch (e) {
      console.error(e);
      setStaffs([]);
    } finally {
      setLoading(false);
    }
  };

  const categoryFetch = async () => {
    setLoading(true);
    try {
      const response = await fetchCategories();
      if (response.data.status) {
        setCategories(response?.data?.data || []);
        console.log("Category API Hit", response?.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  ////// data submit /////

  const handleSubmit = async () => {
    const finalReceiverIds = selectedIds.filter(
      (id) => !alreadyGivenIds.includes(id)
    );

    if (finalReceiverIds.length === 0) {
      SweetAlertShow(
        "info",
        "Warning",
        "Selected receivers already received this category"
      );
      return;
    }

    const payload = {
      receiver_type: distType,
      session_id: sessionId || null,
      batch_id: batchId || null,
      source_id: source || null,

      receiver_id: finalReceiverIds, // ✅ FIXED

      kits: kits.map((k) => ({
        category_id: k.category_id,
        quantity: k.quantity,
        remark: k.remark,
        distribution_date: k.distribution_date,
        collect: k.collect || "NO",
      })),
    };

    setLoading(true);
    try {
      const res = await DistributionAdd(payload);

      if (res?.data?.status) {
        SweetAlertShow("success", "Success", res.data.message);

        setSelectedIds([]);
        setAlreadyGivenIds([]);
        setAllSelect(false);
        setKits([
          {
            category_id: "",
            quantity: 1,
            remark: "",
            distribution_date: today,
            collect: "NO",
          },
        ]);
      } else {
        SweetAlertShow("info", "Warning", res?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (sessionId && (distType === "Student" || distType === "DemoStudent")) {
      setBatchId("");
      setStudents([]);
      fetchBatchList(sessionId);
    }
  }, [sessionId, distType]);

  useEffect(() => {
    fetchSessions();
    categoryFetch();
  }, []);

  useEffect(() => {
    if (distType === "Marketing" && sessionId) {
      setSource("");
      setStudents([]);
      setSelectedIds([]);
      setAllSelect(false);
      fetchMarketingSources();
    }
  }, [sessionId, distType]);

  useEffect(() => {
    if (distType === "Marketing" && sessionId && source) {
      setStudents([]);
      setSelectedIds([]);
      setAllSelect(false);
      fetchMarketingStudents(source, 1); // 👈 first page
    }
  }, [source, sessionId, distType]);

  useEffect(() => {
    if (distType === "Staff") {
      setStudents([]);
      setSelectedIds([]);
      setAllSelect(false);
      fetchStaffs();
    }
  }, [distType, sessionId]);

  /* ---------- Helpers ---------- */

  const getCurrentList = () => {
    if (distType === "Student" || distType === "DemoStudent") return students;
    if (distType === "Marketing") return students; // ✅ students, NOT sources
    if (distType === "Staff") return staffs; // ✅ API data
    return [];
  };

  const currentList = getCurrentList();

  const resetOnTypeChange = (val) => {
    setDistType(val);
    setBatchId("");
    setSource("");
    setSelectedIds([]);
    setAllSelect(false);
    setKits([{ category_id: "", quantity: 1, remark: "" }]);

    if (val === "Staff") {
      setBatchList([]);
      setStudents([]);
      return;
    }

    if (val === "Student" || val === "DemoStudent") {
      fetchBatchList(); // 👈 dono me batch aayega
    }
  };

  /* ---------- Selection Logic ---------- */
  const toggleAll = () => {
    if (allSelect) {
      setSelectedIds([]);
      setAllSelect(false);
    } else {
      setSelectedIds(currentList.map((i) => i.id));
      setAllSelect(true);
    }
  };

  const toggleOne = (id) => {
    if (alreadyGivenIds.includes(id)) return;

    setSelectedIds((prev) => {
      const updated = prev.includes(id)
        ? prev.filter((i) => i !== id)
        : [...prev, id];

      setAllSelect(updated.length === currentList.length);
      return updated;
    });
  };

  /* ---------- Kit Logic ---------- */
  const addKit = () => {
    setKits([
      ...kits,
      {
        category_id: "",
        quantity: 1,
        remark: "",
        distribution_date: new Date().toISOString().slice(0, 10), // ✅ today
        collect: "NO",
      },
    ]);
  };

  const updateKit = async (i, field, val) => {
    const updated = [...kits];
    updated[i][field] = val;
    setKits(updated);

    // 🔥 category change par already given check
    if (field === "category_id" && val) {
      try {
        const params = {
          category_id: val,
          receiver_type: distType,
          // session_id: sessionId || null,
          batch_id: batchId || null,
          source_id: source || null,
        };

        const res = await DistributionAlreadyGiven(params);

        if (res?.data?.status) {
          const ids = res.data.data.map((id) => Number(id));

          setAlreadyGivenIds(ids);

          setSelectedIds((prev) => Array.from(new Set([...prev, ...ids])));

          setAllSelect(false);
        }
      } catch (e) {
        console.error("Already given fetch error", e);
      }
    }
  };

  const removeKit = (i) => {
    setKits(kits.filter((_, idx) => idx !== i));
  };

  const isSubmitDisabled =
    selectedIds.length === 0 ||
    kits.some((k) => !k.category_id || k.quantity < 1);

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Header />
        <div className="layout-page">
          <Nav />
          <div className="content-wrapper">
            <div className="container-fluid mt-2">
              <div className="row custom-scroll-layout">
                {/* LEFT */}
                <div className="col-md-2 left-pane">
                  <DocumentHeader data="Documents Portal" />
                </div>

                {/* RIGHT */}
                <div className="col-md-10 right-pane">
                  <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h4 className="text-primary m-0">Distributed</h4>

                      <button
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => navigate(-1)}
                      >
                        ← Back
                      </button>
                    </div>

                    <div className="card-body">
                      {/* ROW 1 */}
                      <div className="row g-3 mb-3">
                        <div className="col-md-4">
                          <div className="form-floating form-floating-outline">
                            <select
                              className="form-select"
                              value={distType}
                              onChange={(e) =>
                                resetOnTypeChange(e.target.value)
                              }
                            >
                              <option value="">Select</option>
                              <option value="Student">Student</option>
                              <option value="DemoStudent">Demo Student</option>
                              <option value="Marketing">Marketing</option>
                              <option value="Staff">Staff</option>
                            </select>
                            <label>Distributed To</label>
                          </div>
                        </div>

                        {distType !== "Staff" && (
                          <div className="col-md-4">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                value={sessionId}
                                onChange={(e) => setSessionId(e.target.value)}
                              >
                                <option value="">Select Session</option>
                                {sessions.map((s) => (
                                  <option key={s.id} value={s.id}>
                                    {s.session} (
                                    {s.status === "0"
                                      ? "Upcoming"
                                      : s.status === "1"
                                      ? "Active"
                                      : s.status === "2"
                                      ? "Completed"
                                      : "Deleted"}
                                    )
                                  </option>
                                ))}
                              </select>
                              <label>Session</label>
                            </div>
                          </div>
                        )}

                        {(distType === "Student" ||
                          distType === "DemoStudent") && (
                          <div className="col-md-4">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                value={batchId}
                                onChange={(e) => {
                                  const id = e.target.value;
                                  setBatchId(id);
                                  setSelectedIds([]);
                                  setAllSelect(false);

                                  if (!id) return;

                                  if (distType === "Student") {
                                    fetchStudentsByBatch(id);
                                  }

                                  if (distType === "DemoStudent") {
                                    fetchDemoStudentsByBatch(id);
                                  }
                                }}
                              >
                                <option value="">Select Batch</option>
                                {batchList.map((batch) => (
                                  <option key={batch.id} value={batch.id}>
                                    {batch.title}
                                  </option>
                                ))}
                              </select>
                              <label>Batch</label>
                            </div>
                          </div>
                        )}

                        {distType === "Marketing" && (
                          <div className="col-md-4">
                            <div className="form-floating form-floating-outline">
                              <select
                                className="form-select"
                                value={source}
                                onChange={(e) => {
                                  setSource(e.target.value);
                                  setSelectedIds([]);
                                  setAllSelect(false);
                                }}
                              >
                                <option value="">Select Source</option>
                                {marketingSources.map((src) => (
                                  <option key={src.id} value={src.id}>
                                    {src.name}
                                  </option>
                                ))}
                              </select>
                              <label>Source</label>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* ROW 2 – LIST */}
                      {distType === "Marketing" && totalPages > 1 && (
                        <div className="d-flex justify-content-center gap-3 mt-3">
                          <button
                            className="btn btn-sm btn-outline-primary"
                            disabled={page === 1}
                            onClick={() =>
                              fetchMarketingStudents(source, page - 1)
                            }
                          >
                            Prev
                          </button>

                          <span className="align-self-center fw-bold">
                            Page {page} / {totalPages}
                          </span>

                          <button
                            className="btn btn-sm btn-outline-primary"
                            disabled={page === totalPages}
                            onClick={() =>
                              fetchMarketingStudents(source, page + 1)
                            }
                          >
                            Next
                          </button>
                        </div>
                      )}

                      {distType &&
                        (distType === "Staff" ||
                          (batchId &&
                            (distType === "Student" ||
                              distType === "DemoStudent")) ||
                          (source && distType === "Marketing")) && (
                          <>
                            <h6>Selection List :-</h6>

                            {currentList.length === 0 ? (
                              <div className=" text-center text-danger mt-2">
                                Data Not Found
                              </div>
                            ) : (
                              <>
                                <div className="mb-2">
                                  <input
                                    type="checkbox"
                                    checked={allSelect}
                                    onChange={toggleAll}
                                  />{" "}
                                  <b>All Select</b>
                                </div>

                                <div className="row">
                                  {currentList.map((item) => (
                                    <div
                                      className="col-md-3 mb-2"
                                      key={item.id}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={
                                          selectedIds.includes(item.id) ||
                                          alreadyGivenIds.includes(item.id)
                                        }
                                        disabled={alreadyGivenIds.includes(
                                          item.id
                                        )}
                                        onChange={() => toggleOne(item.id)}
                                      />{" "}
                                      {item.name} ({item.reg_no})
                                    </div>
                                  ))}
                                </div>
                              </>
                            )}
                          </>
                        )}

                      {/* ROW 3 – KIT (after Distributed To) */}
                      {distType && (
                        <>
                          <hr />
                          <div className="d-flex justify-content-between align-items-center">
                            <h6>Kit Details</h6>
                            <button
                              type="button"
                              className="btn btn-sm btn-success"
                              onClick={addKit}
                            >
                              + Add Category
                            </button>
                          </div>

                          {kits.map((k, i) => (
                            <div className="row mt-2 align-items-end" key={i}>
                              {/* Category */}
                              <div className="col-md-3">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    value={k.category_id}
                                    onChange={(e) =>
                                      updateKit(
                                        i,
                                        "category_id",
                                        e.target.value
                                      )
                                    }
                                  >
                                    <option value="">Select Category</option>
                                    {categories.length === 0 ? (
                                      <option disabled>
                                        No Category Found
                                      </option>
                                    ) : (
                                      categories.map((cat) => (
                                        <option key={cat.id} value={cat.id}>
                                          {cat.title}
                                        </option>
                                      ))
                                    )}
                                  </select>
                                  <label>Category</label>
                                </div>
                              </div>

                              {/* Quantity */}
                              <div className="col-md-1">
                                <input
                                  type="number"
                                  min="1"
                                  className="form-control"
                                  value={k.quantity}
                                  onChange={(e) =>
                                    updateKit(i, "quantity", e.target.value)
                                  }
                                />
                              </div>

                              {/* Distribution Date */}
                              <div className="col-md-2">
                                <input
                                  type="date"
                                  className="form-control"
                                  value={k.distribution_date}
                                  onChange={(e) =>
                                    updateKit(
                                      i,
                                      "distribution_date",
                                      e.target.value
                                    )
                                  }
                                />
                              </div>

                              {/* Collect */}
                              <div className="col-md-2">
                                <div className="form-floating form-floating-outline">
                                  <select
                                    className="form-select"
                                    value={k.collect}
                                    onChange={(e) =>
                                      updateKit(i, "collect", e.target.value)
                                    }
                                  >
                                    <option value="NO">NO</option>
                                    <option value="YES">YES</option>
                                  </select>
                                  <label>Collected</label>
                                </div>
                              </div>

                              {/* Remark */}
                              <div className="col-md-3">
                                <input
                                  className="form-control input-uppercase"
                                  placeholder="Remark"
                                  value={k.remark}
                                  onChange={(e) =>
                                    updateKit(i, "remark", e.target.value)
                                  }
                                />
                              </div>

                              {/* Remove */}
                              <div className="col-md-1">
                                {kits.length > 1 && (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => removeKit(i)}
                                  >
                                    ✕
                                  </button>
                                )}
                              </div>
                            </div>
                          ))}

                          <div className="text-end mt-4">
                            <button
                              className="btn btn-primary"
                              disabled={isSubmitDisabled || loading}
                              onClick={handleSubmit}
                            >
                              Submit
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentsDistribution;
